<template>
  <div class="home-ecological">
    <div class="container">
      <div>
        <div class="home-ecological-title">{{ $t("home.ecological") }}</div>
      </div>
      <div class="home-ecological-line"></div>

      <div class="home-ecological-content">
        <img
          class="home-ecological-img"
          src="../../assets/home/ecological-construction.png"
          :alt="$t('home.ecological')"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeEcological',
}
</script>

<style scoped>
.home-ecological {
  margin-top: 60px;
  margin-bottom: 60px;
}
.home-ecological-title {
  display: inline-block;
  font-size: 32px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(73, 145, 201, 1);
  line-height: 45px;
}
.home-ecological-line {
  margin-top: 8px;
  height: 1px;
  background: rgba(240, 240, 240, 1);
}
.home-ecological-content {
  margin-top: 40px;
  text-align: center;
}
.home-ecological-img {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}
</style>
